export class CustomComment {
    id?: string;
    user: string;
    createdDate: string;
    text: string;
    lastUpdate?: string;
    attachments_file_names?: string[];
  
    constructor(
      id: string,
      user: string,
      createdDate: string,
      text: string,
      lastUpdate,
      attachments?: string[]
    ) {
      this.id = id;
      this.user = user;
      this.createdDate = createdDate;
      this.text = text;
      this.lastUpdate = lastUpdate;
      this.attachments_file_names = attachments ?? []; // ✅ Default to an empty array if undefined
    }
  }
  